import { FormGroup } from '@angular/forms';
import { ModelForm } from './form-helpers.model';
import { ReducedFundData } from './fund.model';
import { Pagination, PaginationForm } from './pagination.model';

export interface MovementFilter {
  fundos?: ReducedFundData[];
  idArquivo?: number;
  idTipoMovimento?: number;
  dateMovimento?: string;
  dateImportacao?: string;
  conciliado?: boolean;
  recebivel?: {
    id?: number;
    valorNominal?: number;
    valorAquisicao?: number;
    dataAquisicao?: string;
    dataVencimento?: string;
    dataVencimentoInicio?: string;
    dataVencimentoFim?: string;
    taxaCessao?: number;
    taxaAquisicao?: number;
    seuNumero?: string;
    numeroDocumento?: string;
    sacado?: {
      idSacado?: number;
      nomeSacado?: string;
      cnpjSacado?: string;
    };
    cedente?: {
      nomeCedente?: string;
      cnpjCedente?: string;
      idCedente?: number;
    };
  };
}

export interface MovementFilterForm extends MovementFilter {
  paginator: FormGroup<ModelForm<PaginationForm>>;
}

export interface Movement {
  id: number;
  arquivo: {
    iD_ARQUIVO: number;
    iC_COMPACTADO: boolean;
    dT_ENTRADA: string;
    dT_IMPORTACAO: string;
    iD_FUNDO_ORIGINADOR: number;
    cD_LAYOUT: number;
    nM_ARQUIVO: string;
    nM_ARQUIVO_ENTRADA: string;
    iC_PROC_REMOCAO: boolean;
    iC_STATUS_PROC: string;
    iC_TEMPORARIO: boolean;
    iD_FUNDO: number;
    iD_USUARIO: number;
    iD_FUNDO_COBRANCA: number;
    tipO_LAYOUT: string;
    horariO_FIM_VALIDACAO: boolean;
    cD_ORIGINADOR: string;
    iC_ARQUIVO_REMESSA_RETORNO_CASH: boolean;
    iC_ARQUIVO_RETORNO_GERADO: boolean;
    nM_OCORRENCIA: string;
    iC_REMESSA_GERADA: boolean;
  };
  tipoMovimento: {
    id: number;
    nome: string;
    codigo: string;
  };
  valorMovimentacao: number;
  dateMovimento: string;
  dateImportacao: string;
  recebivel: {
    id: number;
    valorNominal: number;
    valorAquisicao: number;
    dataAquisicao: string;
    dataVencimento: string;
    dataVencimentoInicio?: string;
    dataVencimentoFim?: string;
    taxaCessao: number;
    taxaAquisicao: number;
    seuNumero: string;
    numeroDocumento: string;
    sacado: {
      idSacado: number;
      nomeSacado: string;
      cnpjSacado: string;
    };
    cedente: {
      nomeCedente: string;
      cnpjCedente: string;
      idCedente: number;
    };
  };
  fundo: {
    id: number;
    nome: string;
    cnpj: string;
  };
}

export interface MovementPaged extends Pagination {
  items: Movement[];
}

export interface MovementTable {
  id: number;
  fundo: string;
  dateImportacao: string;
  seuNumero: string;
  nmrDocumento: string;
  dataVencimento: string;
  valorAquisicao: number;
  valorTitulo: number;
  valorMovimentacao: number;
}

export interface MovementTablePaged extends Pagination {
  items: MovementTable[];
}
export interface MovementProcess {
  idRecebivel: number;
  idTipoMovimento: number;
  idUsuario: number;
  valorMovimentacao: number;
  dataVencimento: string;
}
